// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c7e3f76910e11b59158d5cff1280449e1248576c.chunk.bundle.js";
};